module.exports = __webpack_public_path__ + "static/bhakti-d0fc7ace97692796f86ab827b19fa1eb.jpg";